import { Module } from 'vuex';

import { DcCalendar } from 'frontend/types/daily-challenges';
import { RootState } from 'frontend/types';

const INITIAL_STATE: Module<DcCalendar, RootState> = {
  namespaced: true,
  state: {
    calendar: [],
  },
  getters: {},
  mutations: {
    setValue(state: DcCalendar, value: DcCalendar): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default INITIAL_STATE;
